import { type CSSProperties, type FC, type ReactElement, type ReactNode } from "react";

import { HStack } from "widgets";

import { selMessage } from "../../messages/message.js";
import { TooltipController } from "../core/overlays/components/OverlayControllers.js";

interface FieldTitleProps {
  label: string | JSX.Element;
  title?: string;
  mandatory?: boolean;
  labelIcon?: ReactNode;
  iconStyle?: CSSProperties;
  rightElement?: string | JSX.Element;
}

const FieldTitle: FC<FieldTitleProps> = (props): ReactElement => {
  if (!props.label) {
    return null;
  }

  const title = props.title ? props.title : props.mandatory ? selMessage({ id: "form.input.tooltip.mandatory" }) : null;
  const labelIcon = props.labelIcon ? props.labelIcon : props.mandatory ? <>*</> : null;

  return (
    <TooltipController content={title}>
      {(tooltipTriggerProps) => (
        <HStack>
          <span>
            {props.label}
            <sup style={props.iconStyle} {...tooltipTriggerProps}>
              {labelIcon}
            </sup>
          </span>
          {props.rightElement}
        </HStack>
      )}
    </TooltipController>
  );
};

export { FieldTitle };
